// extracted by mini-css-extract-plugin
export default {"Answers":"styles_Answers__Blm3u","Shake":"styles_Shake__6JfQ4","shake":"styles_shake__9DehN"};